import { useEffect, useState } from 'react';
import './App.css';
import 'typeface-open-sans';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'primeicons/primeicons.css';

function App() {

  const [showPopup, setShowPopup] = useState(false);
  const [theme, setTheme] = useState('light');
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState('all');
  const [id, setId] = useState(null);

  const categoriesDictionary = [
    { 'comp': 'Completed' },
    { 'imp': 'Important' },
    { 'tos': 'To study' },
    { 'urg': 'Urgent' },
    { 'lat': 'Later' },
  ];

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
    document.body.classList.toggle('dark-bg', theme === 'light');
  };


  useEffect(() => {
    // Retrieve tasks from local storage
    const storedTasks = localStorage.getItem('personal-task-tasks');
    const initialTasks = storedTasks ? JSON.parse(storedTasks) : [];
    setTasks(initialTasks);
  }, [])

  const handleCategory = (selectedCategory) => {
    if (category === selectedCategory) {
      setCategory(''); // Deselect the active category if clicked again
    } else {
      setCategory(selectedCategory); // Set the clicked category as active
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setShowEditPopup(false);
    setCategory('');
  };

  const submitTask = () => {
    if (description === '' || category === '') {
      toast.error('Please fill the form!', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000, // Close the toast after 3 seconds
        hideProgressBar: true, // Hide the progress bar
        pauseOnHover: false // Do not pause the timer on hover
      });
    } else {
      // add task to list and to local storage
      const storedTasks = localStorage.getItem('personal-task-tasks');
      const initialTasks = storedTasks ? JSON.parse(storedTasks) : [];
      const newTask = { description, category };
      const updatedTasks = [...initialTasks, newTask];

      // Update tasks in state and local storage
      setTasks(updatedTasks);
      localStorage.setItem('personal-task-tasks', JSON.stringify(updatedTasks));

      // clear form and close popup
      closePopup();
      toast.success('Task added!', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000, // Close the toast after 3 seconds
        hideProgressBar: true, // Hide the progress bar
        pauseOnHover: false // Do not pause the timer on hover
      });
      setDescription('');
    }
  };

  const filterList = (filterBy) => {
    setFilter(filterBy);
  };

  const clearCompleted = () => {
    const storedTasks = localStorage.getItem('personal-task-tasks');
    const initialTasks = storedTasks ? JSON.parse(storedTasks) : [];

    const updatedTasks = [...initialTasks.filter((task) => task.category !== 'comp')];

    // Update tasks in state and local storage
    setTasks(updatedTasks);
    localStorage.setItem('personal-task-tasks', JSON.stringify(updatedTasks));
  };

  const handleEdit = (id) => {
    setShowEditPopup(true);
    setId(id);
  };

  const editCategory = (selectedCategory) => {
    if (category === selectedCategory) {
      setCategory(''); // Deselect the active category if clicked again
    } else {
      setCategory(selectedCategory); // Set the clicked category as active
    }
  };

  const editTask = () => {
    if (category === '') {
      closePopup(true);
    } else {
      // add task to list and to local storage
      const storedTasks = localStorage.getItem('personal-task-tasks');
      const initialTasks = storedTasks ? JSON.parse(storedTasks) : [];
      console.log(initialTasks[id]);

      const updatedTasks = [...initialTasks.map((task, i) => {
        if (id === i) {
          console.log("hh");
          return { description: task.description, category: category }
        } else {
          return task
        }
      })];

      // Update tasks in state and local storage
      setTasks(updatedTasks);
      localStorage.setItem('personal-task-tasks', JSON.stringify(updatedTasks));

      // clear form and close popup
      closePopup();
      toast.success('Task edited!', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000, // Close the toast after 3 seconds
        hideProgressBar: true, // Hide the progress bar
        pauseOnHover: false // Do not pause the timer on hover
      });
    }
  };

  return (
    <div>
      <div class='top-bar'>
        <label>Personal Task Manager</label>
        {theme === 'light' && <button className='dark-mode' onClick={() => { toggleTheme() }}>
          <i className="pi pi-moon" style={{ fontSize: '24px', opacity: 0.9 }}></i>
        </button>}
        {theme === 'dark' && <button className='dark-mode' onClick={() => { toggleTheme() }}>
          <i className="pi pi-sun" style={{ fontSize: '24px', color: '#fff' }}></i>
        </button>}
      </div>
      <div>
        <div className='content'>
          <div className='tasks-card'>
            <div className='categories'>
              <div>
                <div className='line-title'>
                  <label>Categories</label>
                </div>
                <div className='labels'>
                  <button className='tag comp'>Completed</button>
                  <button className='tag urg'>Urgent</button>
                  <button className='tag imp'>Imporant</button>
                  <button className='tag lat'>Later</button>
                  <button className='tag tos'>To study</button>
                </div>
              </div>
              {/* <button className='add-btn'>Add Category</button> */}
            </div>
            <div className='tasks'>
              <div className='header'>
                <label className='tasks-word'>Tasks</label>
                <button className='add-btn' onClick={() => setShowPopup(true)}>Add New Task</button>

                {/* popup */}
                {showPopup ? <>
                  <div className="overlay"></div>
                  <div className='popup'>
                    <div className='close-btn'>
                      <button onClick={() => closePopup()}>
                        X
                      </button>
                    </div>
                    {/* <label className='title'>CREARE TASK</label> */}
                    <div className='input-container'>
                      <input value={description} onChange={(value) => setDescription(value.target.value)} type='text' className='description' placeholder='Task description...' />
                    </div>

                    <div className='labels'>
                      <button
                        id='comp'
                        className={`tag comp ${category === 'comp' && 'active'}`}
                        onClick={() => handleCategory('comp')}
                      >
                        Completed
                      </button>
                      <button
                        id='urg'
                        className={`tag urg ${category === 'urg' && 'active'}`}
                        onClick={() => handleCategory('urg')}
                      >
                        Urgent
                      </button>
                      <button
                        id='imp'
                        className={`tag imp ${category === 'imp' && 'active'}`}
                        onClick={() => handleCategory('imp')}
                      >
                        Important
                      </button>
                      <button
                        id='lat'
                        className={`tag lat ${category === 'lat' && 'active'}`}
                        onClick={() => handleCategory('lat')}
                      >
                        Later
                      </button>
                      <button
                        id='tos'
                        className={`tag tos ${category === 'tos' && 'active'}`}
                        onClick={() => handleCategory('tos')}
                      >
                        To Study
                      </button>
                    </div>
                    <div className='submit-container'>
                      <button className='submit' onClick={() => submitTask()}>SUBMIT TASK</button>

                    </div>
                  </div>

                </> : <></>
                }

                <button onClick={() => clearCompleted()} className='clear-comp'><label>Clear completed</label></button>
              </div>
              <div className='body'>
                {tasks.length !== 0 ? <ul>
                  {filter === 'all' &&
                    tasks.map((task, i) => {
                      return (
                        <li key={i}>
                          <div className='row'>
                            <div className='check'>&#x2713;</div>
                            <p>{task.description}</p>
                          </div>
                          <div className='row'>
                            <label className={`tag ${task.category
                              }`}>{categoriesDictionary.map((obj) => obj[task.category])}</label>
                            <button onClick={() => handleEdit(i)} className='edit-btn'>
                              <label>
                                <i className="pi pi-file-edit" style={{ fontSize: '18px' }}></i>
                              </label>
                            </button>
                          </div>
                        </li>
                      )
                    })}
                  {/* edit popup */}
                  {showEditPopup ? <>
                    <div className="overlay"></div>
                    <div className='popup'>
                      <div className='close-btn'>
                        <button onClick={() => closePopup()}>
                          X
                        </button>
                      </div>
                      <div className='labels'>
                        <button
                          id='comp'
                          className={`tag comp ${category === 'comp' && 'active'}`}
                          onClick={() => editCategory('comp')}
                        >
                          Completed
                        </button>
                        <button
                          id='urg'
                          className={`tag urg ${category === 'urg' && 'active'}`}
                          onClick={() => editCategory('urg')}
                        >
                          Urgent
                        </button>
                        <button
                          id='imp'
                          className={`tag imp ${category === 'imp' && 'active'}`}
                          onClick={() => editCategory('imp')}
                        >
                          Important
                        </button>
                        <button
                          id='lat'
                          className={`tag lat ${category === 'lat' && 'active'}`}
                          onClick={() => editCategory('lat')}
                        >
                          Later
                        </button>
                        <button
                          id='tos'
                          className={`tag tos ${category === 'tos' && 'active'}`}
                          onClick={() => editCategory('tos')}
                        >
                          To Study
                        </button>
                      </div>
                      <div className='submit-container'>
                        <button className='submit' onClick={() => editTask()}>SAVE</button>

                      </div>
                    </div>

                  </> : <></>
                  }
                  {filter === 'completed' &&
                    tasks.filter((task) => task.category === 'comp').map((task, i) => {
                      return (
                        <li key={i}>
                          <div className='row'>
                            <div className='check'>&#x2713;</div>
                            <p>{task.description}</p>
                          </div>
                          <div className='row'>
                            <label className={`tag ${task.category
                              }`}>{categoriesDictionary.map((obj) => obj[task.category])}</label>
                            <button onClick={() => handleEdit(i)} className='edit-btn'>
                              <label>
                                <i className="pi pi-file-edit" style={{ fontSize: '18px' }}></i>
                              </label>
                            </button>
                          </div>
                        </li>
                      )
                    })}
                  {filter === 'active' &&
                    tasks.filter((task) => task.category !== 'comp' && task.category !== 'tos').map((task, i) => {
                      return (
                        <li key={i}>
                          <div className='row'>
                            <div className='check'>&#x2713;</div>
                            <p>{task.description}</p>
                          </div>
                          <div className='row'>
                            <label className={`tag ${task.category
                              }`}>{categoriesDictionary.map((obj) => obj[task.category])}</label>
                            <button onClick={() => handleEdit(i)} className='edit-btn'>
                              <label>
                                <i className="pi pi-file-edit" style={{ fontSize: '18px' }}></i>
                              </label>
                            </button>
                          </div>
                        </li>
                      )
                    })}
                </ul> : <div className='placeholder'>
                  <p>you have no tasks</p>
                </div>}
                <div className='footer'>
                  <button className={filter === 'active' && `white`} onClick={() => filterList('active')}><label>Active</label></button>
                  <button className={filter === 'all' && `white`} onClick={() => filterList('all')}><label>All</label></button>
                  <button className={filter === 'completed' && `white`} onClick={() => filterList('completed')}><label>Completed</label></button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <ToastContainer />

    </div>
  );
}

export default App;